module.exports = __webpack_public_path__ + "static/media/Logo-Header.c40a3198.svg";